export default {
    state(){
        return{
           isLoading : true
        }
    }
}
